import React, {useEffect, useState} from 'react';
import {Button, FormControl, FormControlLabel, Grid, MenuItem, Select, Switch, Tab, Tabs} from '@material-ui/core'
import {
    ArrayInput,
    BooleanInput,
    DateInput,
    FormDataConsumer,
    maxLength,
    minLength,
    NumberInput,
    regex,
    required,
    SelectInput,
    showNotification,
    SimpleFormIterator,
    TextInput,
    translate
} from 'react-admin';
import {schoolYears, showWarningNotify} from "../../components";
import axiosInstance from "../../api/axios";
import {compose} from "redux";
import {connect} from "react-redux";
import withStyles from '@material-ui/core/styles/withStyles';
import {GenderInput} from "../../components/Gender";
import {Redirect} from 'react-router-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import cloneDeep from 'lodash/cloneDeep';
import {InsuranceTypeInput} from "../../components/InsuranceType";
import {ReligionTypeInput} from "../../components/ReligionType";
import {NationTypeInput} from "../../components/NationType";
import {NationalityTypeInput} from "../../components/NationalityType";
import {SwimTypeInput} from "../../components/SwimType";
import Address from "./Address";
import AddressThuong from "./AddressThuong";

const OTHER_CITY_OPTION = {id: 'OTHER', name: 'Khác'};
const DONT_HAVE_INSURANCE = 'Không có';
const GENDER_CHOICES = [
    {id: 'MALE', name: 'Nam'},
    {id: 'FEMALE', name: 'Nữ'},
];

const requiredField = required('Bắt buộc');
const maxLen = length => maxLength(length, `Không quá ${length} ký tự`);
const phoneValidate = [
    maxLen(10),
    minLength(10, 'Không ít hơn 10 ký tự'),
    regex(/^(\d{10})$/, 'SĐT không hợp lệ')
];
const requiredPhone = [requiredField, ...phoneValidate];
const identifierValidate = regex(/^(\d{12})$/, 'Căn cước không hợp lệ');
const yobValidate = [
    maxLen(4),
    minLength(4, 'Không ít hơn 4 ký tự'),
    regex(/^(\d{4})$/, 'Năm sinh không hợp lệ')
];
const requiredIf = predicate => (value, values = {}, props) =>
    predicate(values) ? requiredField(value, values, props) : undefined;
const requiredIfHaveFather = requiredIf(values => !!values.haveFatherInfo);
const requiredIfHaveMother = requiredIf(values => !!values.haveMotherInfo);
const requiredIfNoMother = requiredIf(values => !values.haveMotherInfo);
const requiredFatherIdentifier = requiredIf(values => values.haveFatherInfo && !values.noFatherIdentifierNumber);
const requiredMotherIdentifier = requiredIf(values => values.haveMotherInfo && !values.noMotherIdentifierNumber);
const requiredIfTrue = source => requiredIf(values => !!values[source]);
const requiredIfOtherCity = requiredIf(values => values.noiSinhCity === OTHER_CITY_OPTION.id);
const max200 = maxLen(200);
const max50 = maxLen(50);
const max100 = maxLen(100);
const max150 = maxLen(150);
const max255 = maxLen(255);
const getBooleanValue = (event, value) =>
    typeof value === 'undefined' ? !!(event && event.target && event.target.checked) : value;

const styles = {
    button: {
        margin: 1,
    },
    selectArray: {
        minWidth: '90%',
    },
    width90: {
        width: '90%',
    },
    label: {fontWeight: 'bold', fontSize: 16},
    cancelBtn: {
        marginLeft: 20
    },
    checkboxGroup: {
        "& > div ": {
            flexDirection: 'column',
        }
    },
    customCheckBox: {
        "& > div > label ": {
            width: '100%'
        }
    }
};


const AdmissionFieldsThuong = props => {
    const [values, setValues] = React.useState({
        isRedirect: false,
        refreshList: false,
        openWhiteList: false,
        units: [],
        selectedElectives: []
    });
    const {
        defaultValue,
        save,
        allProgramServices,
        programServices,
        setProgramServices,
        schoolServices,
        setSchoolServices,
        selectedElectives, setSelectedElectives,
        selectedGraduations, setSelectedGraduations,
        selectedPhysicals, setSelectedPhysicals,
        useCategory, categories,
        selectedCategory,
        setSelectedCategory,
        regisGraduation,

    } = props;

    const [electives, setElectives] = useState([])
    const [physicals, setPhysicals] = useState([])
    const [graduations, setGraduations] = useState([])
    const [provinces, setProvinces] = useState([])

    const [tabIndex, setTabIndex] = React.useState(-1);

    useEffect(() => {
        if (!defaultValue.isRedirect) {
            setValues({...values})
        } else {
            setValues({isRedirect: true, refreshList: true});
        }
    }, [defaultValue.isRedirect]);

    useEffect(() => {
        if (defaultValue.ready) {
            setTabIndex(0)
            loadElectives()
            loadProvinces();

        }
    }, [defaultValue.ready]);

    const loadProvinces = () => {
        axiosInstance.get('/api/provinces').then((rs) => {
            const data = rs.data?.data || rs.data?.content || []
            setProvinces([...data, OTHER_CITY_OPTION])
        })
    }

    const loadElectives = () => {
        axiosInstance.get(`/api/admissionSubjects/search/findBySchoolYearAndActive?schoolYearId=${schoolYears[0].id}`).then((rs) => {
            if (rs.data) {
                const content = rs.data.content

                if (useCategory) {
                    if (defaultValue.categoryId) {
                        const arr1 = categories.filter(c => c.id == defaultValue.categoryId)
                        if (arr1.length > 0) {
                            const category = arr1[0]
                            setSelectedCategory(category)
                            const subjects = category.subjects
                            setElectives(subjects.filter(s => !s.forced))
                        }
                    }
                } else {
                    const arr1 = content.filter(p => p.type === 'ELECTIVE')
                    setElectives(arr1)
                }

                const arr2 = content.filter(p => p.type === 'PHYSICAL')
                setPhysicals(arr2)

                const arr3 = content.filter(p => p.type === 'GRADUATION')
                for (let i = 0; i < arr3.length; i++) {
                    arr3[i].admissionSubjectId = arr3[i].id
                }
                for (let i = 0; i < defaultValue.selectedElectives?.length; i++) {
                    const e = defaultValue.selectedElectives[i]
                    if (e.name) {
                        e.type = 'ELECTIVE'
                        e.forced = false
                        arr3.push(e)
                    }
                }
                setGraduations(arr3)
            }
        })
    }
    const handleChangeCategory = async (event) => {
        const itemValue = event.target.value
        const prev = selectedCategory.id
        if (prev != itemValue) {
            const category = categories.filter(c => c.id == itemValue)[0]
            if (category) {
                setSelectedCategory(category)
                const subjects = category.subjects
                setElectives(subjects)
                const forcedSubjects = subjects.filter(s => s.forced)
                const removeSubjectIds = []
                const newSelectedElectives = [...selectedElectives]
                const graduations2 = [...graduations]
                for (let i = 0; i < selectedElectives.length; i++) {
                    const elective = selectedElectives[i]
                    if (elective.admissionSubjectId) {
                        removeSubjectIds.push(selectedElectives[i].admissionSubjectId)
                    }
                    if (i < forcedSubjects.length) {
                        const clone = cloneDeep(forcedSubjects[i])
                        clone.type = 'ELECTIVE'
                        clone.admissionSubjectId = itemValue
                        clone.displayIndex = i + 1
                        newSelectedElectives[i] = clone

                        const cloneGraduation = cloneDeep(forcedSubjects[i])
                        cloneGraduation.type = 'ELECTIVE'
                        cloneGraduation.admissionSubjectId = itemValue
                        cloneGraduation.forced = false
                        const idx = graduations2.findIndex(p => p.name == clone.name)
                        if (idx < 0) {
                            graduations2.push(cloneGraduation)
                        }
                    } else {
                        newSelectedElectives[i] = {
                            admissionSubjectId: '',
                            type: 'ELECTIVE',
                            displayIndex: i + 1
                        }
                    }
                }
                setSelectedElectives(newSelectedElectives)
                if (removeSubjectIds.length > 0) {
                    const newGraduations = [...selectedGraduations]
                    for (let i = 0; i < removeSubjectIds.length; i++) {
                        const selectedGraduationIdx = selectedGraduations.findIndex(p => p.admissionSubjectId == removeSubjectIds[i])
                        if (selectedGraduationIdx >= 0) {
                            newGraduations[selectedGraduationIdx] = {
                                ...newGraduations[selectedGraduationIdx],
                                admissionSubjectId: '',
                                name: ''
                            }
                        }
                    }
                    setSelectedGraduations(newGraduations)
                    setGraduations(graduations2.filter(p => removeSubjectIds.indexOf(p.admissionSubjectId) < 0))
                    setProgramServices(programServices.filter(p => !p.admissionSubjectId || removeSubjectIds.indexOf(p.admissionSubjectId) < 0))
                } else {
                    setGraduations(graduations2.filter(p => removeSubjectIds.indexOf(p.admissionSubjectId) < 0))
                }
            }
        }
    }

    const handleChangeElective = (event, index) => {
        const itemValue = event.target.value
        handleChangeElectiveByValue(itemValue, index, electives)
    }

    const handleChangeElectiveByValue = (itemValue, index, electives) => {
        const prev = selectedElectives[index]
        if (prev.admissionSubjectId != itemValue) {
            const idx1 = selectedElectives.findIndex(p => p.admissionSubjectId && p.admissionSubjectId === itemValue)
            if (idx1 >= 0) {
                showWarningNotify('Vui lòng đăng ký môn tự chọn khác nhau.')
                return
            }
            const chose = electives.filter(e => e.id == itemValue)[0]
            const clone = cloneDeep(chose)
            clone.type = 'ELECTIVE'
            clone.admissionSubjectId = itemValue
            clone.displayIndex = index + 1
            const existIdx = graduations.findIndex(p => p.name == clone.name)
            if (existIdx < 0) {
                const cloneGraduation = cloneDeep(chose)
                cloneGraduation.type = 'ELECTIVE'
                cloneGraduation.admissionSubjectId = itemValue
                cloneGraduation.forced = false
                const idx = graduations.findIndex(p => p.name == prev.name)
                if (idx >= 0) {
                    graduations[idx] = cloneGraduation
                } else {
                    graduations.push(cloneGraduation)
                }
            }
            const newArr1 = [...selectedElectives]
            newArr1[index] = clone
            setSelectedElectives(newArr1)

            const arr5 = [...selectedGraduations]
            const selectedGraduationIdx = arr5.findIndex(p => !p.admissionSubjectId && p.admissionSubjectId == prev.admissionSubjectId)
            if (selectedGraduationIdx >= 0) {
                arr5[selectedGraduationIdx] = {
                    ...arr5[selectedGraduationIdx],
                    admissionSubjectId: '',
                    name: ''
                }
                setSelectedGraduations(arr5)
            }
            changeDependentProgramServices([...newArr1, ...arr5]);
        }
    }
    const handleChangePhysical = (event, index) => {
        const itemValue = event.target.value
        const prev = selectedPhysicals[index]
        if (prev.admissionSubjectId != itemValue) {
            const idx1 = selectedPhysicals.findIndex(p => p.admissionSubjectId && p.admissionSubjectId == itemValue)
            if (idx1 >= 0) {
                showWarningNotify('Vui lòng đăng ký môn thể chất khác nhau.')
                return
            }
            const chose = physicals.filter(e => e.id == itemValue)[0]
            const clone = cloneDeep(chose)
            clone.type = 'PHYSICAL'
            clone.admissionSubjectId = itemValue
            clone.displayIndex = index + 1
            const newArr1 = [...selectedPhysicals]
            newArr1[index] = clone
            setSelectedPhysicals(newArr1)
        }
    }
    const handleChangeGraduation = (event, index) => {
        const itemValue = event.target.value
        const prev = selectedGraduations[index]
        if (prev.admissionSubjectId != itemValue) {
            const idx1 = selectedGraduations.findIndex(p => p.admissionSubjectId && p.admissionSubjectId == itemValue)
            if (idx1 >= 0) {
                showWarningNotify('Vui lòng đăng ký môn tốt nghiệp khác nhau.')
                return
            }
            const chose = graduations.filter(e => e.admissionSubjectId == itemValue)[0]
            if (chose) {
                const clone = cloneDeep(chose)
                clone.admissionSubjectId = itemValue
                clone.displayIndex = index + 1
                const newArr1 = [...selectedGraduations]
                newArr1[index] = clone
                setSelectedGraduations(newArr1)
                changeDependentProgramServices([...selectedElectives, ...newArr1]);
            }
        }
    }

    function changeDependentProgramServices(arr) {
        const serviceArr = allProgramServices.filter(p => !p.admissionSubjectId || arr.findIndex(s => p.admissionSubjectId == s.admissionSubjectId) >= 0)
        if (serviceArr.length > 0) {
            let existArr = [...programServices]
            const newArr = []
            for (let i = 0; i < serviceArr.length; i++) {
                const ser = serviceArr[i]
                const arr2 = existArr.filter(s => (!s.admissionSubjectId && s.id == ser.id) && (ser.admissionSubjectId == s.admissionSubjectId))
                if (arr2.length == 0) {
                    ser.selected = ser.defaultValue
                    newArr.push(ser)
                } else {
                    newArr.push(arr2[0])
                }
            }
            setProgramServices(newArr)
        } else {
            setProgramServices([])
        }
    }

    const changeProgramService = (index) => {
        const arr = [...programServices]
        arr[index].selected = !arr[index].selected
        setProgramServices(arr)
    }
    const changeSchoolService = (index) => {
        const arr = [...schoolServices]
        arr[index].selected = !arr[index].selected
        setSchoolServices(arr)
    }
    const handleChangeTab = (event, newValue) => {
        setTabIndex(newValue);
    };

    function cancel() {
        setValues({isRedirect: true, refreshList: false});
    }

    if (values.isRedirect) {
        return <Redirect to={'/admissions?refreshView=' + values.refreshList}/>;
    }
    return (
        <React.Fragment>
            <Grid item xs={12} sm={12}>
                <Tabs value={tabIndex} onChange={handleChangeTab} textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary  tabs example"
                      style={{
                          borderBottom: '1px solid #2979ff',
                      }}
                >
                    <Tab label="Lý lịch" style={{border: '1px solid #2979ff', marginRight: '1px'}}/>
                    <Tab label="Tuyển sinh" style={{
                        border: '1px solid #2979ff',
                        marginRight: '1px',
                        display: 'flex'
                    }}/>
                    <Tab label="Năng khiếu" style={{border: '1px solid #2979ff'}}/>
                </Tabs>
            </Grid>

            {tabIndex === 1 &&
                <React.Fragment>
                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>A) Thông tin học sinh</span>
                    </Grid>

                    <TextInput source="sbd" label="resources.admissions.fields.sbd" disabled/>

                    <Grid item xs={12} sm={4}>
                        <NumberInput source="stt" label="resources.admissions.fields.stt"
                                     onChange={props.onChange('stt')}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="customerName" label="resources.admissions.fields.customerName" disabled/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInput source="dob" label="resources.admissions.fields.dob" disabled/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <GenderInput source="gender" disabled/>
                    </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monVan" label="resources.admissions.fields.monVan" disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monToan" label="resources.admissions.fields.monToan" disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="monAnh" label="resources.admissions.fields.monAnh" disabled/>
                            </Grid>
                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>B) Tổ hợp ưu tiên</span>
                    </Grid>
                    {useCategory ?
                        <>
                            <FormControl fullWidth>
                                <span>Tổ hợp môn học lớp 10*</span>
                                <Select
                                    labelId={"mon-4"}
                                    id={"ban-hoc-select"}
                                    value={selectedCategory.id}
                                    label={false}
                                    onChange={(e) => handleChangeCategory(e)}
                                >
                                    {categories.map((el, index) => (
                                        <MenuItem value={el.id}>{el.name}</MenuItem>
                                    ))
                                    }
                                </Select>
                            </FormControl>
                            {selectedCategory && selectedCategory.id && selectedElectives.map((item, index) => (
                                <Grid item xs={12} sm={6}>
                                    {item.forced ?
                                        <span>{'Môn tự chọn ' + (index + 1) + ': ' + item.name}</span>
                                        :
                                        <FormControl fullWidth>
                                            <span>{'Môn tự chọn ' + (index + 1) + "*"}</span>
                                            <Select
                                                id={"mon-tu-chon-select" + index}
                                                value={item.admissionSubjectId}
                                                label={false}
                                                onChange={(e) => handleChangeElective(e, index)}
                                            >
                                                {electives.map((el, index) => (
                                                    <MenuItem value={el.id}>{el.name}</MenuItem>
                                                ))
                                                }
                                            </Select>
                                        </FormControl>
                                    }
                                </Grid>
                            ))
                            }
                        </>
                        :
                        <>
                            {selectedElectives.map((item, index) => (
                                <Grid key={index} item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <span>{'Tổ hợp ưu tiên ' + (index + 1) + "*"}</span>
                                        <Select
                                            id={"mon-tu-chon-select" + index}
                                            value={item.admissionSubjectId}
                                            label={false}
                                            onChange={(e) => handleChangeElective(e, index)}
                                        >
                                            {electives.map((el, index) => (
                                                <MenuItem value={el.id}>{el.name}</MenuItem>
                                            ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ))
                            }
                        </>

                    }

                    <>
                        <Grid item xs={12} sm={12}>
                            <span style={styles.label}>C) Môn học Giáo dục thể chất tự chọn</span>
                        </Grid>
                        {selectedPhysicals.map((item, index) => (
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <span>{'Môn thể chất ' + (index + 1) + "*"}</span>
                                    <Select
                                        id={"mon-the-chat-select" + index}
                                        value={item.admissionSubjectId}
                                        label={false}
                                        onChange={(e) => handleChangePhysical(e, index)}
                                    >
                                        {physicals.map((el, index) => (
                                            <MenuItem value={el.id}>{el.name}</MenuItem>
                                        ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                        ))
                        }
                        {regisGraduation &&
                            <>
                                <Grid item xs={12} sm={12}>
                                                      <span
                                                          style={styles.label}>D) Các môn dự kiến thi Tốt nghiệp</span>
                                </Grid>
                                {selectedGraduations.map((item, index) => (
                                    <Grid item xs={12} sm={6}>
                                        {item.forced ?
                                            <span>{'Môn tốt nghiệp ' + (index + 1) + ': ' + item.name}</span>
                                            :
                                            <FormControl fullWidth>
                                                <span>{'Môn tốt nghiệp ' + (index + 1) + "*"}</span>
                                                <Select
                                                    id={"mon-tot-nghiep-select" + index}
                                                    value={item.admissionSubjectId}
                                                    label={false}
                                                    onChange={(e) => handleChangeGraduation(e, index)}
                                                >
                                                    {graduations.map((el, index) => (
                                                        el.forced ? <></> :
                                                            <MenuItem
                                                                value={el.admissionSubjectId}>{el.name}</MenuItem>
                                                    ))
                                                    }
                                                </Select>
                                            </FormControl>
                                        }
                                    </Grid>
                                ))
                                }
                            </>
                        }
                        <Grid item xs={12} sm={12}>
                        <span
                            style={styles.label}>{(regisGraduation ? 'E' : 'D') + ') Đăng ký chương trình với nhà trường'}</span>
                        </Grid>
                        {programServices.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControlLabel
                                    labelPlacement="start"
                                    control={<Switch checked={item.selected}
                                                     onChange={() => !item.forced && changeProgramService(index)}/>}
                                    label={item.name}
                                />
                            </Grid>
                        ))
                        }
                        <Grid item xs={12} sm={12}>
                                <span
                                    style={styles.label}>{(regisGraduation ? 'F' : 'E') + ') Các dịch vụ giáo dục'}</span>
                        </Grid>
                        {schoolServices.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControlLabel
                                    labelPlacement="start"
                                    control={<Switch checked={item.selected}
                                                     onChange={() => !item.forced && changeSchoolService(index)}/>}
                                    label={item.name}
                                />
                            </Grid>
                        ))
                        }
                    </>
                </React.Fragment>
            }
            {tabIndex === 0 &&
                <React.Fragment>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.studentInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="customerName" label="resources.admissions.fields.customerName"
                                           disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <GenderInput source="gender" disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="dob" label="resources.admissions.fields.dob" disabled/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="documentNumber" label="resources.admissions.fields.documentNumber"
                                           disabled
                                           onChange={props.onChange('documentNumber')}
                                           validate={maxLen(15)}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <DateInput source="documentIssueDate"
                                           label="resources.admissions.fields.documentIssueDate"
                                           onChange={(e, v) => props.onDirectChange('documentIssueDate', v)}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="documentOrigin" label="resources.admissions.fields.documentOrigin"
                                           onChange={props.onChange('documentOrigin')} style={styles.width90}
                                           validate={max150}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NationTypeInput source="nation" label="resources.admissions.fields.nation" required
                                                 validate={requiredField}
                                                 onChange={(e, v) => props.onDirectChange('nation', v)}
                                                 style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <NationalityTypeInput source="nationality"
                                                      label="resources.admissions.fields.nationality"
                                                      validate={requiredField}
                                                      onChange={(e, v) => props.onDirectChange('nationality', v)}
                                                      style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <ReligionTypeInput source="religion" label="resources.admissions.fields.religion"
                                                   validate={requiredField}
                                                   onChange={(e, v) => props.onDirectChange('religion', v)}
                                                   style={styles.width90}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="customerPhone" label="resources.admissions.fields.customerPhoneThuong"
                                           onChange={props.onChange('customerPhone')} style={styles.width90}
                                           maxLength={10}
                                           required
                                           validate={requiredPhone}/>
                            </Grid>
                            <FormDataConsumer>
                                {({formData}) => (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <SelectInput source="noiSinhCity" label="resources.admissions.fields.pob"
                                                         choices={provinces}
                                                         onChange={(e, v) => {
                                                             props.onDirectChange('noiSinhCity', v);
                                                             if (v !== OTHER_CITY_OPTION.id) {
                                                                 props.onDirectChange('noiSinhKhac', '');
                                                             }
                                                         }}
                                                         style={styles.width90}
                                                         validate={requiredField}/>
                                        </Grid>
                                        {formData.noiSinhCity === OTHER_CITY_OPTION.id &&
                                            <Grid item xs={12} sm={4}>
                                                <TextInput source="noiSinhKhac" label="resources.admissions.fields.pob"
                                                           onChange={props.onChange('noiSinhKhac')}
                                                           style={styles.width90}
                                                           validate={[requiredIfOtherCity, max255]}/>
                                            </Grid>
                                        }
                                    </>
                                )}
                            </FormDataConsumer>
                        </Grid>
                    </Grid>
                    <AddressThuong onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='permanentAddress'/>
                    <AddressThuong onChange={props.onChange} onDirectChange={props.onDirectChange}
                             prefixField='temporaryAddress'/>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.fatherInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <BooleanInput source="haveFatherInfo" label="Có thông tin Cha"
                                              onChange={(e, v) => props.onDirectChange('haveFatherInfo', getBooleanValue(e, v))}/>
                            </Grid>
                            <FormDataConsumer>
                                {({formData}) => formData.haveFatherInfo && (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="fatherName"
                                                       label="resources.admissions.fields.fatherName"
                                                       onChange={props.onChange('fatherName')} style={styles.width90}
                                                       validate={[requiredIfHaveFather, max50]}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="fatherDob" label="resources.admissions.fields.fatherDob"
                                                       onChange={props.onChange('fatherDob')} style={styles.width90}
                                                       validate={[requiredIfHaveFather, ...yobValidate]}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="fatherPhone"
                                                       label="resources.admissions.fields.fatherPhone"
                                                       onChange={props.onChange('fatherPhone')} style={styles.width90}
                                                       validate={phoneValidate}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <BooleanInput source="noFatherIdentifierNumber" label="Không có CCCD Cha"
                                                          onChange={(e, v) => props.onDirectChange('noFatherIdentifierNumber', getBooleanValue(e, v))}/>
                                        </Grid>
                                        {!formData.noFatherIdentifierNumber &&
                                            <Grid item xs={12} sm={4}>
                                                <TextInput source="fatherIdentifierNumber"
                                                           label="resources.admissions.fields.fatherIdentifierNumber"
                                                           onChange={props.onChange('fatherIdentifierNumber')}
                                                           style={styles.width90}
                                                           validate={[requiredFatherIdentifier, identifierValidate]}/>
                                            </Grid>
                                        }
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="fatherJob" label="resources.admissions.fields.fatherJob"
                                                       onChange={props.onChange('fatherJob')} style={styles.width90}
                                                       validate={[requiredIfHaveFather, max50]}/>
                                        </Grid>
                                    </>
                                )}
                            </FormDataConsumer>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.motherInfo`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <BooleanInput source="haveMotherInfo" label="Có thông tin Mẹ"
                                              onChange={(e, v) => props.onDirectChange('haveMotherInfo', getBooleanValue(e, v))}/>
                            </Grid>
                            <FormDataConsumer>
                                {({formData}) => formData.haveMotherInfo && (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="motherName"
                                                       label="resources.admissions.fields.motherName"
                                                       onChange={props.onChange('motherName')} style={styles.width90}
                                                       validate={[requiredIfHaveMother, max50]}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="motherDob" label="resources.admissions.fields.motherDob"
                                                       onChange={props.onChange('motherDob')} style={styles.width90}
                                                       validate={[requiredIfHaveMother, ...yobValidate]}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="motherPhone"
                                                       label="resources.admissions.fields.motherPhone"
                                                       onChange={props.onChange('motherPhone')} style={styles.width90}
                                                       validate={phoneValidate}/>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <BooleanInput source="noMotherIdentifierNumber" label="Không có CCCD Mẹ"
                                                          onChange={(e, v) => props.onDirectChange('noMotherIdentifierNumber', getBooleanValue(e, v))}/>
                                        </Grid>
                                        {!formData.noMotherIdentifierNumber &&
                                            <Grid item xs={12} sm={4}>
                                                <TextInput source="motherIdentifierNumber"
                                                           label="resources.admissions.fields.motherIdentifierNumber"
                                                           onChange={props.onChange('motherIdentifierNumber')}
                                                           style={styles.width90}
                                                           validate={[requiredMotherIdentifier, identifierValidate]}/>
                                            </Grid>
                                        }
                                        <Grid item xs={12} sm={4}>
                                            <TextInput source="motherJob" label="resources.admissions.fields.motherJob"
                                                       onChange={props.onChange('motherJob')} style={styles.width90}
                                                       validate={[requiredIfHaveMother, max50]}/>
                                        </Grid>
                                    </>
                                )}
                            </FormDataConsumer>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                <span
                                    style={styles.label}>{props.translate(`resources.admissions.fields.guardianInfoThuong`)}</span>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianName" label="resources.admissions.fields.guardianNameThuong"
                                           onChange={props.onChange('guardianName')} style={styles.width90}
                                           validate={[requiredIfNoMother, max50]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <SelectInput source="guardianGender" label="resources.admissions.fields.gender"
                                             choices={GENDER_CHOICES}
                                             onChange={(e, v) => props.onDirectChange('guardianGender', v)}
                                             style={styles.width90}
                                             validate={requiredIfNoMother}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianDob" label="resources.admissions.fields.guardianDobThuong"
                                           onChange={props.onChange('guardianDob')} style={styles.width90}
                                           validate={[requiredIfNoMother, ...yobValidate]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianPhone" label="resources.admissions.fields.guardianPhone"
                                           onChange={props.onChange('guardianPhone')} style={styles.width90}
                                           validate={[requiredIfNoMother, ...phoneValidate]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianIdentifierNumber"
                                           label="resources.admissions.fields.guardianIdentifierNumberThuong"
                                           onChange={props.onChange('guardianIdentifierNumber')} style={styles.width90}
                                           validate={[requiredIfNoMother, identifierValidate]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="guardianJob" label="resources.admissions.fields.guardianJobThuong"
                                           onChange={props.onChange('guardianJob')} style={styles.width90}
                                           validate={[requiredIfNoMother, max50]}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <span style={styles.label}>Thông tin khác</span>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <SwimTypeInput source="canSwim" label="resources.admissions.fields.canSwim"
                                       onChange={(e, v) => props.onDirectChange('canSwim', v)}
                                       style={styles.width90}
                                       validate={requiredField}/>
                    </Grid>
                    {defaultValue.canSwim === true &&
                        <>
                            <Grid item xs={12} sm={3}>
                                <TextInput source="swimCertificate" label="resources.admissions.fields.swimCertificate"
                                           onChange={props.onChange('swimCertificate')} style={styles.width90}
                                           validate={[requiredField, max100]}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextInput source="swimPlaceOfCertificate"
                                           label="resources.admissions.fields.swimPlaceOfCertificate"
                                           onChange={props.onChange('swimPlaceOfCertificate')} style={styles.width90}
                                           validate={[requiredField, max100]}/>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <DateInput source="swimDateOfCertificate"
                                           label="resources.admissions.fields.swimDateOfCertificate"
                                           validate={requiredField}
                                           onChange={(e, v) => props.onDirectChange('swimDateOfCertificate', v)}/>
                            </Grid>
                        </>
                    }
                    <Grid item xs={12} sm={3}>
                        <TextInput source="baseInsuranceNumber" label="resources.admissions.fields.baseInsuranceNumber"
                                            onChange={(e, v) => props.onDirectChange('baseInsuranceNumber', v)}
                                            maxLength={20}
                                            required
                                            style={styles.width90}
                                            validate={requiredField}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextInput source="baseInsurancePlace" label="resources.admissions.fields.baseInsurancePlace"
                                            onChange={(e, v) => props.onDirectChange('baseInsurancePlace', v)}
                                            maxLength={100}
                                            required
                                            style={styles.width90}
                                            validate={requiredField}/>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <InsuranceTypeInput source="otherInsurance" label="resources.admissions.fields.otherInsurance"
                                            onChange={(e, v) => props.onDirectChange('otherInsurance', v)}
                                            style={styles.width90}
                                            validate={requiredField}/>
                    </Grid>
                    {defaultValue.otherInsurance && defaultValue.otherInsurance != DONT_HAVE_INSURANCE &&
                        <Grid item xs={12} sm={3}>
                            <TextInput source="insuranceNumber" label="resources.admissions.fields.insuranceNumber"
                                       onChange={props.onChange('insuranceNumber')} style={styles.width90}
                                       validate={[requiredField, maxLen(20)]}/>
                        </Grid>
                    }
                </React.Fragment>
            }
            {tabIndex === 2 &&
                <React.Fragment>
                    <Grid item xs={12} sm={12}>
                        <BooleanInput source="haveCultureGifted" label="Văn hoá - Nghệ thuật"
                                      onChange={(e, v) => props.onDirectChange('haveCultureGifted', getBooleanValue(e, v))}/>
                    </Grid>
                    {defaultValue.haveCultureGifted &&
                        <ArrayInput source="cultures" label={false}>
                            <SimpleFormIterator inline disableAdd={true} disableClear={true} disableRemove={true}
                                                disableReordering={true}>
                                <TextInput source="name" label="resources.admissions.fields.giftedName2"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('cultures', 'name', 0)}
                                           validate={[requiredIfTrue('haveCultureGifted'), max200]}/>
                                <TextInput source="achievement" label="resources.admissions.fields.giftedAchievement"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('cultures', 'achievement', 0)}
                                           validate={[requiredIfTrue('haveCultureGifted'), max200]}/>
                                <TextInput source="note" label="resources.admissions.fields.giftedNote"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('cultures', 'note', 0)}
                                           validate={max200}/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    }

                    <Grid item xs={12} sm={12}>
                        <BooleanInput source="haveSportGifted" label="Thể dục thể thao"
                                      onChange={(e, v) => props.onDirectChange('haveSportGifted', getBooleanValue(e, v))}/>
                    </Grid>
                    {defaultValue.haveSportGifted &&
                        <ArrayInput source="sports" label={false}>
                            <SimpleFormIterator inline disableAdd={true} disableClear={true} disableRemove={true}
                                                disableReordering={true}>
                                <TextInput source="name" label="resources.admissions.fields.giftedName"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('sports', 'name', 0)}
                                           validate={[requiredIfTrue('haveSportGifted'), max200]}/>
                                <TextInput source="achievement" label="resources.admissions.fields.giftedAchievement"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('sports', 'achievement', 0)}
                                           validate={[requiredIfTrue('haveSportGifted'), max200]}/>
                                <TextInput source="note" label="resources.admissions.fields.giftedNote"
                                           style={styles.width90}
                                           onChange={props.handleChangeArray('sports', 'note', 0)}
                                           validate={max200}/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    }

                    <Grid item xs={12} sm={12}>
                        <BooleanInput source="haveTeamGifted" label="Công tác Đoàn đội - Phong trào học sinh"
                                      onChange={(e, v) => props.onDirectChange('haveTeamGifted', getBooleanValue(e, v))}/>
                    </Grid>
                    {defaultValue.haveTeamGifted &&
                        <>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="team.name" label="resources.admissions.fields.team"
                                           onChange={props.onChange('team.name')} style={styles.width90}
                                           validate={[requiredIfTrue('haveTeamGifted'), max200]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="team.achievement"
                                           label="resources.admissions.fields.giftedAchievement"
                                           onChange={props.onChange('team.achievement')} style={styles.width90}
                                           validate={[requiredIfTrue('haveTeamGifted'), max200]}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextInput source="team.note" label="resources.admissions.fields.giftedNote"
                                           onChange={props.onChange('team.note')} style={styles.width90}
                                           validate={max200}/>
                            </Grid>
                        </>
                    }

                    <Grid item xs={12} sm={12}>
                        <BooleanInput source="haveOtherGifted" label="Năng khiếu khác"
                                      onChange={(e, v) => props.onDirectChange('haveOtherGifted', getBooleanValue(e, v))}/>
                    </Grid>
                    {defaultValue.haveOtherGifted &&
                        <Grid item xs={12} sm={4}>
                            <TextInput source="otherGifted.name" label="resources.admissions.fields.otherGifted"
                                       onChange={props.onChange('otherGifted.name')} style={styles.width90}
                                       validate={[requiredIfTrue('haveOtherGifted'), max200]}/>
                        </Grid>
                    }
                </React.Fragment>
            }
            <Grid item xs={12} sm={12} style={{marginTop: 15}}>
                {defaultValue.active &&
                    <Button variant="contained"
                            color="primary"
                            style={styles.button}
                            disabled={defaultValue.saveDisabled}
                            onClick={save}>
                        <SaveIcon/> Lưu
                    </Button>
                }
                <Button variant="contained" style={styles.cancelBtn}
                        onClick={cancel}>
                    <CancelIcon/> Hủy
                </Button>
            </Grid>
        </React.Fragment>
    )
}

export default compose(translate, connect(null, {showNotification}), withStyles(styles))(AdmissionFieldsThuong)
